import { Fragment, FunctionComponent, PropsWithChildren } from 'react'
import { useAuthContext } from '@/modules/Auth/contexts/AuthContext'
import { useClariStore } from '../../store'
import { Redirect } from 'react-router-dom'
import { useStyles } from './styles'
import { Interpolation, Theme } from '@emotion/react'

interface ClariPageProps {
  style?: Interpolation<Theme>
  params?: string
}

const ClariPage: FunctionComponent<ClariPageProps> = ({
  style,
  params,
}: PropsWithChildren<ClariPageProps>) => {
  const { user, token } = useAuthContext()
  const { clariIntent } = useClariStore()
  const styles = useStyles()

  if (!token || !user?.patientId) {
    return <Redirect to={'/'} />
  }

  let finalParams: string = params ?? ''
  if (clariIntent && !finalParams.includes('intent=')) {
    finalParams = `${finalParams}&intent=${clariIntent}`
  }

  return (
    <Fragment>
      <iframe
        title="Clari"
        css={style ?? styles.iframe}
        allow="camera; microphone; clipboard-read; clipboard-write;"
        src={`${process.env.VITE_APP_CLARI_URL}/?token=${token}${finalParams}`}
      ></iframe>
    </Fragment>
  )
}

export default ClariPage
